import { Logo2 } from '../SvgIcons'
import './styles.less'

export default function Logo({ width, height, className = '' }) {
  const style = {
    width,
    height,
    display: 'inline-block',
  }
  return (
    <div
      style={style}
      className={`rsuite-logo logo-animated logo-animated-delay-half-seconds bounceIn ${className} `}
    >
      {/* <img src={Logo2} style={{ width, height }}></img> */}
      <img src={Logo2} style={{ width: '100%', height: 'auto' }}></img>
    </div>
  )
}
